import { Layout, NotFound404, PrivateRoutes } from "@therapprove/common";
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes,
    useParams
} from "react-router-dom";
import { CustomScripts } from "../pages/CustomScripts/CustomScripts";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { Files } from "../pages/Files/Files";
import { ForgotPassword } from "../pages/ForgotPassword/ForgotPassword";
import { Login } from "../pages/Login/Login";
import pages from "../pages/pages";
import { GlobalPriorityEntries } from "../pages/PriorityEntry/GlobalPriorityEntries";
import { PriorityEntries } from "../pages/PriorityEntry/PriorityEntries";
import { PriorityEntryDetails } from "../pages/PriorityEntry/PriorityEntryDetails";
import { PriorityInvites } from "../pages/PriorityInvites/PriorityInvites";
import { Referrals } from "../pages/PriorityReferrals/PriorityReferrals";
import { Team } from "../pages/Team/Team";
import { WebsiteLeads } from "../pages/WebsiteLeads/WebsiteLeads";
import { TherapproveOverlayProvider } from "../TherapproveOverlayProvider";

interface AppProps {
    onSessionChange?: () => void;
}

function LegacyPriorityEntryRedirect() {
    const { priorityEntryId } = useParams();
    if (!priorityEntryId) {
        return <Navigate to="/referral-pipeline" replace />;
    }
    return <Navigate to={`/referral-pipeline/${priorityEntryId}`} replace />;
}

// The main component of the application.
function App({ onSessionChange }: AppProps) {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PrivateRoutes />}>
                    <Route
                        element={
                            <TherapproveOverlayProvider>
                                <Layout
                                    pages={pages}
                                    onSessionChange={onSessionChange}
                                />
                            </TherapproveOverlayProvider>
                        }
                    >
                        <Route
                            path="/"
                            element={<Navigate to="/dashboard" replace />}
                        />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/team" element={<Team />} />
                        <Route
                            path="/referral-pipeline"
                            element={<PriorityEntries />}
                        />
                        <Route
                            path="/referral-pipeline/:priorityEntryId"
                            element={<PriorityEntryDetails />}
                        />
                        <Route
                            path="/global-referrals"
                            element={<GlobalPriorityEntries />}
                        />
                        <Route
                            path="/website-leads"
                            element={<WebsiteLeads />}
                        />
                        <Route path="/invites" element={<PriorityInvites />} />
                        <Route
                            path="/direct-referrals"
                            element={<Referrals />}
                        />
<Route path="/files" element={<Files />} />
                        <Route
                            path="/custom-scripts"
                            element={<CustomScripts />}
                        />
                        {/* Legacy redirects */}
                        <Route
                            path="/myOrganization"
                            element={<Navigate to="/dashboard" replace />}
                        />
                        <Route
                            path="/organizations/:organizationId"
                            element={<Navigate to="/dashboard" replace />}
                        />
                        <Route
                            path="/locations"
                            element={<Navigate to="/dashboard" replace />}
                        />
                        <Route
                            path="/organization-admins"
                            element={<Navigate to="/team" replace />}
                        />
                        <Route
                            path="/coordinators"
                            element={<Navigate to="/team" replace />}
                        />
                        <Route
                            path="/providers"
                            element={<Navigate to="/team" replace />}
                        />
                        <Route
                            path="/my-queue/:priorityEntryId"
                            element={<LegacyPriorityEntryRedirect />}
                        />
                        <Route
                            path="/my-queue"
                            element={
                                <Navigate to="/referral-pipeline" replace />
                            }
                        />
                        <Route
                            path="/global-queue"
                            element={
                                <Navigate to="/global-referrals" replace />
                            }
                        />
                        <Route
                            path="/referrals"
                            element={
                                <Navigate to="/direct-referrals" replace />
                            }
                        />
                    </Route>
                </Route>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="*" element={<NotFound404 />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
